// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list-button-style {
  font-size: 16px; /* text-base (16px) */
  font-weight: 500; /* font-medium */
  width: 100%; /* w-full */
  text-align: start; /* text-start */
  white-space: nowrap; /* truncate */
  overflow: hidden; /* truncate */
  text-overflow: ellipsis; /* truncate */
  background-color: transparent; /* bg-transparent */
  border: 0; /* border-0 */
  padding: 0; /* p-0 */
  margin: 0; /* m-0 */
}

.card-list-wrapper {
  background-color: #fff;
  padding: 16px 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.item-wrapper {
  padding: 7px;
  min-height: 10px;
  font-size: 1.05rem;
}

.search-bar-wrapper {
  position: sticky;
  top: 0;
  height: 100px;
  background-color: #fff;
  z-index: 999;
  padding: 24px 32px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.small-tag {
  font-size: 12px !important; /* forcefully override */
}

.small-button {
  font-size: 10px !important; /* smaller text */
  padding: 2px 5px !important; /* shrink padding */
  height: 30px !important; /* optional: control height */
  min-width: auto !important; /* optional: remove min width */
}

.custom-input-width {
  height: 38px !important;
}

.nowrap-btn {
  white-space: nowrap;
  flex-shrink: 0;
}

.custom-input-margin {
  height: 39px !important;
}

.react-select.smaller-control .react-select__control {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 0.75rem !important;
}

.react-select.smaller-control .react-select__value-container {
  height: 100px !important;
  padding: 0 6px !important;
}

.react-select.smaller-control .react-select__input {
  margin: 0px !important;
}

.react-select.smaller-control .react-select__indicators {
  height: 30px !important;
}

.small-input input {
  max-width: 80px !important; /* adjust as needed */
  font-size: 0.875rem; /* text-sm */
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 9999px; /* Full rounded */
  font-size: 12px;
  font-weight: 100;
  text-align: center;
  white-space: nowrap;
}

.status-active {
  background-color: #dcf6d9; /* Light Green */
  color: #1B5E20; /* Dark Green */
}

/* Inactive (Gray) */
.status-inactive {
  background-color: #E0E0E0; /* Light Gray */
  color: #424242; /* Dark Gray */
}

.add-more {
  color: #42B0D5;
  cursor: pointer;
  font-size: 12px;
}

.senerio-button {
  position: absolute;
  right: 22px;
  top: 22px;
}

.simulation-section {
  height: 92vh;
  position: relative;
}
.simulation-section .Vessel-Out .MultiSelect__multi-value:first-child .MultiSelect__multi-value__remove {
  pointer-events: none !important;
  opacity: 0;
}
.simulation-section .close-icon {
  display: flex;
  border-radius: 2px;
  padding-left: 4px;
  padding-right: 4px;
  box-sizing: border-box;
}
.simulation-section .dtco-performa-option-active {
  background-color: var(--performa-option-active);
}
.simulation-section .dtco-performa-option-active:hover {
  background-color: var(--performa-option-hover);
}
.simulation-section .dtco-performa-option-disabled {
  background-color: var(--performa-option-disabled);
  color: var(--performa-option-disabled-color) !important;
  cursor: not-allowed;
  pointer-events: all !important;
}
.simulation-section .DuplicateModal .ServiceList {
  margin-top: 15px;
}
.simulation-section .RefreshBtn {
  position: absolute;
  right: 0px;
  top: 0px;
}
.simulation-section .inputSearch {
  position: absolute;
  right: 0px;
  top: 0px;
}
.simulation-section .DuplicateModal .MultiSelect__value-container {
  max-height: 150px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .filter-div .MultiSelect__value-container {
  height: 35px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .filter-div .MultiSelect__placeholder {
  text-transform: none;
}
.simulation-section .filter-div .input-label {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
}
.simulation-section .filter-div .wrapper-inputDate > div .inputDate {
  min-height: 37px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid rgb(207, 207, 207);
}
.simulation-section .simulation-generation {
  padding: 10px 10px 15px;
  border: solid 1px var(--border-color);
  margin-bottom: 20px;
  background: var(--color-white);
}
.simulation-section .simulation-generation button {
  margin-top: 28px;
}
.simulation-section .simulation-generation .MultiSelect__value-container {
  height: 36px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.simulation-section .simulation-generation .MultiSelect__indicators button {
  margin-top: 0px;
}
.simulation-section .simulation-generation .MultiSelect__multi-value__label {
  font-size: var(--font-size-sm);
}
.simulation-section .data-section {
  background: var(--color-white);
  border: solid 1px var(--border-color);
  padding: 10px;
}
.simulation-section .data-section .result-header {
  position: relative;
  margin-bottom: 2rem;
}
.simulation-section .data-section .result-header .filter-div {
  padding: 5px 5px 10px 5px;
  background: #f5f5f5;
}
.simulation-section .data-section .result-header .search {
  position: absolute;
  right: 0;
  top: 5px;
}
.simulation-section .data-section .simulationList {
  border: solid 1px var(--border-color);
  background: var(--color-white);
  display: flex;
  margin-top: 30px;
  border-radius: 0px;
  position: relative;
}
.simulation-section .data-section .simulationList .opt-type-display {
  position: absolute;
  top: -18px;
  font-size: 10px;
  color: white;
  background-color: var(--color-maersk-blue);
  padding: 1px 5px;
  left: 0px;
  border-radius: 3px 3px 0px 0px;
}
.simulation-section .data-section .simulationList .icon-section {
  padding: 5px;
  margin: 0px 10px;
}
.simulation-section .data-section .simulationList .value-section {
  width: 100%;
}
.simulation-section .data-section .simulationList .value-section .mainheader {
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.simulation-section .data-section .simulationList .value-section .mainheader .vesel-status {
  background: var(--color-lightGreen);
  padding: 2px 6px;
  border-radius: 3px;
  color: #007800;
  font-size: var(--font-size-sm);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  display: inline-block;
  margin-left: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle {
  font-size: 14px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section {
  margin-bottom: 15px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .header {
  color: var(--color-font);
  font-weight: 700;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .time-details {
  color: var(--color-font);
  font-size: var(--font-size-xs);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .content {
  font-size: 14px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .content .showmore {
  color: #0073ab;
  text-decoration: underline;
  margin-left: 5px;
  font-size: var(--font-size-sm);
  cursor: pointer;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tags {
  border-radius: 20px;
  padding: 1px 5px;
  line-height: 16px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tags span {
  font-size: var(--font-size-sm);
  white-space: nowrap;
  font-weight: normal;
  color: #00243d;
  border-radius: 3px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .icon-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .icon-section .icon-list {
  margin-right: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  width: 200px;
  color: var(--color-black);
  font-size: 12px;
  background-color: var(--color-white);
  border-radius: 10px;
  padding: 10px 15px 10px 15px;
  border: solid 1px var(--border-color);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .hover-text:hover .tooltip-text {
  visibility: visible;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section #top {
  top: -50px;
  left: -6rem;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .upper-section .hover-text {
  position: relative;
  display: inline-block;
  text-align: center;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .header {
  color: #545454;
  font-size: var(--font-size-sm);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section {
  height: 38px;
  display: flex;
  text-align: center;
  margin-top: 5px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress {
  width: 100px;
  margin-left: 5px;
  border: solid 1px var(--color-maersk-darkblue);
  align-items: center;
  display: flex;
  justify-content: center;
  background: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.error {
  background-color: var(--color-lightRed);
  color: #970000;
  border: solid 1px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.success {
  background-color: var(--color-lightGreen);
  color: #009700;
  border: solid 1px;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.active {
  display: block;
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress.active .step {
  background-color: var(--color-maersk-darkblue);
  color: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .data-subtitle .progress-section .step-progress .time {
  font-size: var(--font-size-xs);
  background-color: var(--color-maersk-blue);
  color: var(--color-white);
}
.simulation-section .data-section .simulationList .value-section .pull-right {
  float: right;
}
.simulation-section .data-section .simulationList .value-section .button {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SimulationRequest/SenerioRequest.scss"],"names":[],"mappings":"AAAA;EACE,eAAA,EAAA,qBAAA;EACA,gBAAA,EAAA,gBAAA;EACA,WAAA,EAAA,WAAA;EACA,iBAAA,EAAA,eAAA;EACA,mBAAA,EAAA,aAAA;EACA,gBAAA,EAAA,aAAA;EACA,uBAAA,EAAA,aAAA;EACA,6BAAA,EAAA,mBAAA;EACA,SAAA,EAAA,aAAA;EACA,UAAA,EAAA,QAAA;EACA,SAAA,EAAA,QAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;AACF;;AAEA;EACE,0BAAA,EAAA,wBAAA;AACF;;AACA;EACE,0BAAA,EAAA,iBAAA;EACA,2BAAA,EAAA,mBAAA;EACA,uBAAA,EAAA,6BAAA;EACA,0BAAA,EAAA,+BAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAGA;EACE,2BAAA;EACA,uBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,wBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAIA;EACE,0BAAA,EAAA,qBAAA;EACA,mBAAA,EAAA,YAAA;AADF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA,EAAA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,yBAAA,EAAA,gBAAA;EACA,cAAA,EAAA,eAAA;AAVF;;AAaA,oBAAA;AACA;EACE,yBAAA,EAAA,eAAA;EACA,cAAA,EAAA,cAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAVF;;AAaA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAVF;;AAaA;EACE,YAAA;EACA,kBAAA;AAVF;AAYI;EACE,+BAAA;EACA,UAAA;AAVN;AAaE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAXJ;AAaE;EACE,+CAAA;AAXJ;AAcE;EACE,8CAAA;AAZJ;AAeE;EACE,iDAAA;EACA,uDAAA;EACA,mBAAA;EACA,8BAAA;AAbJ;AAgBI;EACE,gBAAA;AAdN;AAiBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAfJ;AAiBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAfJ;AAkBI;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;AAhBN;AAoBI;EACI,YAAA;EACA,6BAAA;EACA,gBAAA;AAlBR;AAqBI;EACI,oBAAA;AAnBR;AAqBI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAnBN;AAqBI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AAnBN;AAsBE;EACE,uBAAA;EACA,qCAAA;EACA,mBAAA;EACA,8BAAA;AApBJ;AAqBI;EACE,gBAAA;AAnBN;AAqBI;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAnBN;AAsBM;EACE,eAAA;AApBR;AAuBI;EACE,8BAAA;AArBN;AAwBE;EACE,8BAAA;EACA,qCAAA;EACA,aAAA;AAtBJ;AAuBI;EACE,kBAAA;EACA,mBAAA;AArBN;AAsBM;EACE,yBAAA;EACA,mBAAA;AApBR;AAsBM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AApBR;AAuBI;EACE,qCAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AArBN;AAsBM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;AApBR;AAsBM;EACE,YAAA;EACA,gBAAA;AApBR;AAsBM;EACE,WAAA;AApBR;AAsBQ;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AApBV;AAqBU;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAnBZ;AAsBQ;EACE,eAAA;AApBV;AAqBU;EACE,mBAAA;AAnBZ;AAoBY;EACE,wBAAA;EACA,gBAAA;AAlBd;AAoBY;EACE,wBAAA;EACA,8BAAA;AAlBd;AAoBY;EACE,eAAA;AAlBd;AAmBc;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AAjBhB;AAoBY;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAlBd;AAmBc;EACE,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAjBhB;AAoBY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBd;AAmBc;EACE,iBAAA;AAjBhB;AAoBY;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;AAlBd;AAqBY;EACE,mBAAA;AAnBd;AAsBY;EACE,UAAA;EACA,WAAA;AApBd;AAsBY;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AApBd;AAuBU;EACE,cAAA;EACA,8BAAA;AArBZ;AAwBU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAtBZ;AAuBY;EACE,YAAA;EACA,gBAAA;EACA,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AArBd;AAsBc;EACE,uCAAA;EACA,cAAA;EACA,iBAAA;AApBhB;AAsBc;EACE,yCAAA;EACA,cAAA;EACA,iBAAA;AApBhB;AAsBc;EACE,cAAA;AApBhB;AAqBgB;EACE,8CAAA;EACA,yBAAA;AAnBlB;AAwBc;EACE,8BAAA;EACA,0CAAA;EACA,yBAAA;AAtBhB;AA2BQ;EACE,YAAA;AAzBV;AA2BQ;EACE,eAAA;AAzBV","sourcesContent":[".card-list-button-style {\n  font-size: 16px;         /* text-base (16px) */\n  font-weight: 500;        /* font-medium */\n  width: 100%;             /* w-full */\n  text-align: start;       /* text-start */\n  white-space: nowrap;     /* truncate */\n  overflow: hidden;        /* truncate */\n  text-overflow: ellipsis; /* truncate */\n  background-color: transparent; /* bg-transparent */\n  border: 0;               /* border-0 */\n  padding: 0;              /* p-0 */\n  margin: 0;               /* m-0 */\n}\n\n.card-list-wrapper {\n  background-color: #fff;\n  padding: 16px 24px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  margin-top: 16px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.item-wrapper {\n  padding: 7px;\n  min-height: 10px;\n  font-size: 1.05rem;\n}\n\n.search-bar-wrapper {\n  position: sticky;\n  top: 0;\n  height: 100px;\n  background-color: #fff;\n  z-index: 999;\n  padding: 24px 32px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.small-tag {\n  font-size: 12px !important;  /* forcefully override */\n}\n.small-button {\n  font-size: 10px !important; /* smaller text */\n  padding: 2px 5px !important; /* shrink padding */\n  height: 30px !important;     /* optional: control height */\n  min-width: auto !important;  /* optional: remove min width */\n}\n\n.custom-input-width {\n  height: 38px !important;\n  // margin-top: -10px;\n}\n\n.nowrap-btn {\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.custom-input-margin {\n  height: 39px !important;\n  // margin-top: -10px;\n}\n\n.react-select.smaller-control .react-select__control {\n  min-height: 30px !important;\n  height: 30px !important;\n  font-size: 0.75rem !important;\n}\n\n.react-select.smaller-control .react-select__value-container {\n  height: 100px !important;\n  padding: 0 6px !important;\n}\n\n.react-select.smaller-control .react-select__input {\n  margin: 0px !important;\n}\n\n.react-select.smaller-control .react-select__indicators {\n  height: 30px !important;\n}\n\n\n.small-input input {\n  max-width: 80px !important; /* adjust as needed */\n  font-size: 0.875rem;         /* text-sm */\n  // padding: 4px 6px;            /* tighter padding */\n}\n\n// .modal {\n//   background-color: #fff;\n//   padding: 24px;\n//   border-radius: 8px;\n//   width: 400px;\n//   max-width: 90%;\n//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n// }\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 9999px; /* Full rounded */\n  font-size: 12px;\n  font-weight: 100;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.status-active {\n  background-color: #dcf6d9; /* Light Green */\n  color: #1B5E20; /* Dark Green */\n}\n\n/* Inactive (Gray) */\n.status-inactive {\n  background-color: #E0E0E0; /* Light Gray */\n  color: #424242; /* Dark Gray */\n}\n\n.add-more {\n  color:#42B0D5;\n  cursor: pointer;\n  font-size:12px;\n}\n\n.senerio-button{\n  position: absolute;\n  right: 22px;\n  top: 22px;\n}\n\n.simulation-section {\n  height: 92vh;\n  position: relative;\n  .Vessel-Out{\n    .MultiSelect__multi-value:first-child .MultiSelect__multi-value__remove {\n      pointer-events: none !important;\n      opacity: 0;\n  }\n  }\n  .close-icon{\n    display: flex;\n    border-radius: 2px;\n    padding-left: 4px;\n    padding-right: 4px;\n    box-sizing: border-box;\n  }\n  .dtco-performa-option-active {\n    background-color: var(--performa-option-active);\n  }\n\n  .dtco-performa-option-active:hover {\n    background-color: var(--performa-option-hover);\n  }\n\n  .dtco-performa-option-disabled {\n    background-color: var(--performa-option-disabled);\n    color: var(--performa-option-disabled-color) !important;\n    cursor: not-allowed;\n    pointer-events: all !important;\n  }\n  .DuplicateModal{\n    .ServiceList{\n      margin-top: 15px;\n    }\n  }\n  .RefreshBtn {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n  }\n  .inputSearch {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n  }\n  .DuplicateModal{\n    .MultiSelect__value-container {\n      max-height: 150px;\n      overflow-x: hidden !important;\n      overflow-y: auto;\n  }\n  }\n  .filter-div{\n    .MultiSelect__value-container {\n        height: 35px;\n        overflow-x: hidden !important;\n        overflow-y: auto;\n    }\n    \n    .MultiSelect__placeholder {\n        text-transform: none;\n    }\n    .input-label{\n      font-size: 14px;\n      line-height: 20px;\n      margin-bottom: 2px;\n    }\n    .wrapper-inputDate > div .inputDate{\n      min-height: 37px;\n      font-size: 14px;\n      border-radius: 3px;\n      border: 1px solid rgb(207, 207, 207);\n    }\n  }\n  .simulation-generation {\n    padding: 10px 10px 15px;\n    border: solid 1px var(--border-color);\n    margin-bottom: 20px;\n    background: var(--color-white);\n    button {\n      margin-top: 28px;\n    }\n    .MultiSelect__value-container {\n      height: 36px;\n      overflow-x: hidden !important;\n      overflow-y: auto;\n    }\n    .MultiSelect__indicators {\n      button {\n        margin-top: 0px;\n      }\n    }\n    .MultiSelect__multi-value__label {\n      font-size: var(--font-size-sm);\n    }\n  }\n  .data-section {\n    background: var(--color-white);\n    border: solid 1px var(--border-color);\n    padding: 10px;\n    .result-header {\n      position: relative;\n      margin-bottom: 2rem;\n      .filter-div{\n        padding: 5px 5px 10px 5px;\n        background: #f5f5f5;\n      }\n      .search {\n        position: absolute;\n        right: 0;\n        top: 5px;\n      }\n    }\n    .simulationList {\n      border: solid 1px var(--border-color);\n      background: var(--color-white);\n      display: flex;\n      margin-top: 30px;\n      border-radius: 0px;\n      position: relative;\n      .opt-type-display{\n        position: absolute;\n        top: -18px;\n        font-size: 10px;\n        color: white;\n        background-color: var(--color-maersk-blue);\n        padding: 1px 5px;\n        left: 0px;\n        border-radius: 3px 3px 0px 0px;  \n      }\n      .icon-section {\n        padding: 5px;\n        margin: 0px 10px;\n      }\n      .value-section {\n        width: 100%;\n\n        .mainheader {\n          font-weight: 500;\n          line-height: 14px;\n          margin-bottom: 10px;\n          display: flex;\n          align-items: center;\n          .vesel-status {\n            background: var(--color-lightGreen);\n            padding: 2px 6px;\n            border-radius: 3px;\n            color: #007800;\n            font-size: var(--font-size-sm);\n            font-weight: 500;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            max-width: 250px;\n            display: inline-block;\n            margin-left: 5px;\n          }\n        }\n        .data-subtitle {\n          font-size: 14px;\n          .upper-section {\n            margin-bottom: 15px;\n            .header {\n              color: var(--color-font);\n              font-weight: 700;\n            }\n            .time-details{\n              color: var(--color-font);\n              font-size: var(--font-size-xs);\n            }\n            .content {\n              font-size: 14px;\n              .showmore {\n                color: #0073ab;\n                text-decoration: underline;\n                margin-left: 5px;\n                font-size: var(--font-size-sm);\n                cursor: pointer;\n              }\n            }\n            .tags {\n              border-radius: 20px;\n              padding: 1px 5px;\n              line-height: 16px;\n              span {\n                font-size: var(--font-size-sm);\n                white-space: nowrap;\n                font-weight: normal;\n                color: #00243d;\n                border-radius: 3px;\n              }\n            }\n            .icon-section {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              .icon-list {\n                margin-right: 5px;\n              }\n            }\n            .tooltip-text {\n              visibility: hidden;\n              position: absolute;\n              z-index: 1;\n              width: 200px;\n              color: var(--color-black);\n              font-size: 12px;\n              background-color: var(--color-white);\n              border-radius: 10px;\n              padding: 10px 15px 10px 15px;\n              border:solid 1px var(--border-color);\n            }\n\n            .hover-text:hover .tooltip-text {\n              visibility: visible;\n            }\n\n            #top {\n              top: -50px;\n              left: -6rem;\n            }\n            .hover-text {\n              position: relative;\n              display: inline-block;\n              text-align: center;\n            }\n          }\n          .header {\n            color: #545454;\n            font-size: var(--font-size-sm);\n          }\n\n          .progress-section {\n            height: 38px;\n            display: flex;\n            text-align: center;\n            margin-top: 5px;\n            .step-progress {\n              width: 100px;\n              margin-left: 5px;\n              border: solid 1px var(--color-maersk-darkblue);\n              align-items: center;\n              display: flex;\n              justify-content: center;\n              background: var(--color-white);\n              &.error {\n                background-color: var(--color-lightRed);\n                color: #970000;\n                border: solid 1px;\n              }\n              &.success {\n                background-color: var(--color-lightGreen);\n                color: #009700;\n                border: solid 1px;\n              }\n              &.active {\n                display: block;\n                .step {\n                  background-color: var(--color-maersk-darkblue);\n                  color: var(--color-white);\n                }\n              }\n              .step {\n              }\n              .time {\n                font-size: var(--font-size-xs);\n                background-color: var(--color-maersk-blue);\n                color: var(--color-white);\n              }\n            }\n          }\n        }\n        .pull-right {\n          float: right;\n        }\n        .button {\n          margin-top: 8px;\n        }\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
